import { useEffect, useState } from "react";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "Начало", href: "#hero" },
  { label: "Колекция", href: "#collection" },
  { label: "Историята", href: "#manifesto" },
  { label: "Контакт", href: "#contact" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-cream/90 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#hero" className="font-serif text-2xl tracking-tight text-ink" data-testid="brand-logo">
          Айлян<span className="text-clay">.</span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-stone hover:text-ink transition-colors duration-300"
              data-testid={`nav-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setOpen(true)}
            className="relative p-2 text-ink hover:text-clay transition-colors duration-300"
            aria-label="Отвори количката"
            data-testid="cart-toggle"
          >
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 bg-clay text-cream text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-semibold">
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2 text-ink"
            onClick={() => setMobile((m) => !m)}
            aria-label="Меню"
            data-testid="mobile-menu-toggle"
          >
            {mobile ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {mobile && (
        <div className="md:hidden bg-cream border-t border-line px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMobile(false)}
              className="text-lg font-serif text-ink"
              data-testid={`mobile-nav-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
